import styled from 'styled-components'

export const FeaturedWrapper = styled.main``

export const FeaturedCategories = styled.div`
  @media (max-width: 768px) {
    margin-top: ${props => (props.isShowingCta ? '0px' : '16px')};
  }
`
